<template>
	<div class="main">
		<div v-show="!detialshow">
			<SearchForm ref="searchref">
				<template v-slot:btns>
					<a-form-model-item>
						<a-button type="primary" @click="getlist({current:1})">查询</a-button>
					</a-form-model-item>
					<a-form-model-item>
						<downloadexcel
							class="ant-btn ant-btn-primary export-btn"
							:fetch="getdataSource"
							:fields="excelheader"
							:before-finish="exportsuccess"
							name="本页数据.xls"
						>导出本页数据</downloadexcel>
					</a-form-model-item>
					<a-form-model-item>
						<downloadexcel
							class="ant-btn ant-btn-primary export-btn"
							:fields="excelheader"
							:fetch="getAllData"
							:before-finish="exportsuccess"
							name="全部数据.xls"
						>导出全部数据</downloadexcel>
					</a-form-model-item>
					<a-form-model-item>
						<a-button type="primary" @click="showleave">批量离场</a-button>
					</a-form-model-item>
				</template>
			</SearchForm>
			<SumComponent :sumdata="sumdata"></SumComponent>	
			<Table ref="tableref" :godetial="godetial" :confirmfn="confirmfn" :reload = "getlist" ></Table>
			<Pagination :current="current" :pageSize="pageSize" :total="total" :pageChange="pageChange" :pageSizeChange="pageSizeChange"></Pagination>
			<Leave ref="leaveref" :onOk="multioutfn"></Leave>
		</div>

		<div v-if="detialshow">
			<Detial :id="detialId" @backfn="backdetial" @saveCallback="getlist"></Detial>
		</div>
	</div>	
</template>

<script>
import PageComponent from './index.js';
export default PageComponent
</script>
<style >
.export-btn{
	line-height: 30px;
}
.totalinfo{
	margin: 0px 0px 10px 20px;
	display: flex;
	justify-content: flex-start;
}
</style>

